import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { TextField } from 'material-ui';

import Btn from '../../../components/Btn';
import '../../../grid.css';
import './sgip.css';
import { formattedNumber } from '../../../utils/formatterHelpers';

class SGIP extends Component {
    toggleSGIPIsVisible() {
        const { setSGIPIsVisible, isVisible } = this.props;
        setSGIPIsVisible(!isVisible);
    }

    handleSGIPValueChange(value) {
        const { setSGIPValue } = this.props;
        setSGIPValue(Number(value));
    }

    handleSGIPToggle() {
        const { setSGIPToggle, sgipToggle } = this.props;
        setSGIPToggle(!sgipToggle);
    }

    render() {
        const {
            sgipToggle, sgipValue, isVisible, isLocked, sgipTotal, esskW,
        } = this.props;

        return (
            <div>
                <Btn label="SGIP" onClick={(e, value) => this.toggleSGIPIsVisible(value)} />
                {isVisible ? (
                    <div className="row containerSGIP">
                        <div>
                            <div className="col span-1-of-4 checkboxes">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            disabled={isLocked}
                                            onChange={(e, value) => this.handleSGIPToggle(value)}
                                            checked={sgipToggle}
                                        />
                                    }
                                    label="Include SGIP"
                                />
                            </div>
                            {sgipToggle === true ? (
                                <div>
                                    <div className="col span-1-of-4">
                                        <TextField
                                            hintText="8.00"
                                            defaultValue={sgipValue}
                                            onChange={(e, value) =>
                                                this.handleSGIPValueChange(value)}
                                            floatingLabelText="Incentive Rate $/Wh"
                                            disabled={isLocked}
                                        />
                                    </div>
                                    <div>
                                        {esskW < 30 ? (
                                            <div className="col span-1-of-4">
                                                <h1>$ {formattedNumber(sgipTotal)}</h1>
                                                <h3 className="underText">Upfront</h3>
                                            </div>
                                        ) : (
                                            <div>
                                                <div className="col span-1-of-4">
                                                    <h1>$ {formattedNumber(sgipTotal)}</h1>
                                                    <h3 className="underText">Upfront</h3>
                                                </div>
                                                <div className="col span-1-of-4">
                                                    <h1>$ {formattedNumber(sgipTotal)}</h1>
                                                    <h3 className="underText">Total PBI value</h3>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

SGIP.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    isLocked: PropTypes.bool.isRequired,
    setSGIPIsVisible: PropTypes.func.isRequired,
    sgipToggle: PropTypes.bool.isRequired,
    setSGIPValue: PropTypes.func.isRequired,
    setSGIPToggle: PropTypes.func.isRequired,
    sgipValue: PropTypes.number.isRequired,
    sgipTotal: PropTypes.number.isRequired,
    esskW: PropTypes.number.isRequired,
};

SGIP.defaultProps = {};

export default SGIP;



// WEBPACK FOOTER //
// ./src/containers/Inputs/SGIP/SGIP.js